<template>
  <div>

    <div class="remark-header">绿贝小助手8.9</div>

    <div v-if="remark" class="collapsible-section remark-section">
      <div class="section-header" @click="remarkSectionCollapsed = !remarkSectionCollapsed" role="button"
        :aria-expanded="!remarkSectionCollapsed" tabindex="0"
        @keydown.enter.prevent="remarkSectionCollapsed = !remarkSectionCollapsed"
        @keydown.space.prevent="remarkSectionCollapsed = !remarkSectionCollapsed">
        <span>客户信息</span>
        <span class="toggle-icon">{{ remarkSectionCollapsed ? '▶' : '▼' }}</span>
      </div>
      <div v-show="!remarkSectionCollapsed" id="text" class="remark-container">
        <!-- 非联系人内容（到期高亮）。
             remarkWithoutContacts 已自动扪离“各联系人备注：”原标题行与联系人行，
             避免与下方联系人折叠头重复。 -->
        <p v-if="remarkWithoutContacts" v-html="highlightedB"></p>

        <!-- “各联系人备注”：内部组级折叠，默认折叠 -->
        <div v-if="parsedContactLogs.length" class="contact-logs">
          <div class="contact-log-header" @click="contactLogsCollapsed = !contactLogsCollapsed" role="button"
            :aria-expanded="!contactLogsCollapsed" tabindex="0"
            @keydown.enter.prevent="contactLogsCollapsed = !contactLogsCollapsed"
            @keydown.space.prevent="contactLogsCollapsed = !contactLogsCollapsed">
            <span>各联系人备注 ({{ parsedContactLogs.length }})</span>
            <span class="toggle-icon">{{ contactLogsCollapsed ? '▶' : '▼' }}</span>
          </div>
          <ul v-show="!contactLogsCollapsed" class="contact-log-list">
            <li v-for="(log, idx) in parsedContactLogs" :key="idx" class="contact-log-item">
              {{ log.date }}：{{ log.operator }}=>{{ log.target }}
            </li>
          </ul>
        </div>
      </div>
    </div>


    <div v-if="QrodeUrl || chezhengUrl || jiaoqiangUrl || shangyeUrl" class="collapsible-section image-section">
      <div class="section-header" @click="imageSectionCollapsed = !imageSectionCollapsed" role="button"
        :aria-expanded="!imageSectionCollapsed" tabindex="0"
        @keydown.enter.prevent="imageSectionCollapsed = !imageSectionCollapsed"
        @keydown.space.prevent="imageSectionCollapsed = !imageSectionCollapsed">
        <span>一码通或车证保单</span>
        <span class="toggle-icon">{{ imageSectionCollapsed ? '▶' : '▼' }}</span>
      </div>
      <div v-show="!imageSectionCollapsed" class="image-wrapper">
        <img v-if="chezhengUrl" :src="chezhengUrl" alt="车证" class="auto-fit-image" @error="chezhengUrl = ''">
        <img v-if="jiaoqiangUrl" :src="jiaoqiangUrl" alt="交强险" class="auto-fit-image" @error="jiaoqiangUrl = ''">
        <img v-if="shangyeUrl" :src="shangyeUrl" alt="商业险" class="auto-fit-image" @error="shangyeUrl = ''">
        <img v-if="QrodeUrl" :src="QrodeUrl" alt="交款码" class="auto-fit-image" @error="QrodeUrl = ''">
        <a v-if="QrodeUrllink" :href="QrodeUrllink" target="_blank"
          rel="noopener noreferrer" style="display: block; margin-top: 8px; color: #1890ff; text-decoration: underline;">
          打开二维码
        </a>
      </div>
    </div>

    <div v-if="hasLogs" class="collapsible-section log-section">
      <div class="section-header" @click="logSectionCollapsed = !logSectionCollapsed" role="button"
        :aria-expanded="!logSectionCollapsed" tabindex="0"
        @keydown.enter.prevent="logSectionCollapsed = !logSectionCollapsed"
        @keydown.space.prevent="logSectionCollapsed = !logSectionCollapsed">
        <span>查询记录 ({{ logEntries.length }})</span>
        <span class="toggle-icon">{{ logSectionCollapsed ? '▶' : '▼' }}</span>
      </div>
      <!-- 折叠态：仅展示最新一条响应 -->
      <pre v-if="logSectionCollapsed" class="remark-container log-latest">{{ latestLogText }}</pre>
      <!-- 展开态：展示全部日志（保留原 --- 分隔风格） -->
      <pre v-else class="remark-container log-all">{{ logText }}</pre>
    </div>

    <p v-if="loading">尝试获取数据中...</p>

    <!-- 统一错误提示（已合并重复） -->
    <p v-if="error" class="error-text">{{ error }}</p>

    <!-- 轻提示 toast（替代原生 alert，不阻塞页面） -->
    <div v-if="toastMsg" class="toast">{{ toastMsg }}</div>

    <!-- 按钮统一由 :disabled="loading" 控制，按语义分为 3 组 -->
    <fieldset class="action-group action-group--vehicle">
      <legend><span class="legend-badge legend-badge--vehicle" aria-hidden="true">🚗</span>车辆数据类</legend>
      <div class="button-group">
        <button :disabled="loading" @click="fetchData"><span class="btn-icon" aria-hidden="true">🚓</span>交管</button>
        <button :disabled="loading" @click="fetchHTData"><span class="btn-icon" aria-hidden="true">📋</span>备案查询</button>
        <button :disabled="loading" @click="fetchZDData"><span class="btn-icon" aria-hidden="true">📊</span>账单</button>
        <button :disabled="loading" @click="fetchDWData"><span class="btn-icon" aria-hidden="true">📍</span>定位</button>
        <button :disabled="loading" @click="fetchMileData"><span class="btn-icon" aria-hidden="true">📏</span>里程</button>
        <button :disabled="loading" @click="fetchCZGPSData"><span class="btn-icon" aria-hidden="true">🛰️</span>车证GPS</button>
        <button :disabled="loading" @click="fetchWarrantyStatus"><span class="btn-icon" aria-hidden="true">📄</span>车证保单</button>
      </div>
    </fieldset>



    <fieldset class="action-group action-group--payment">
      <legend><span class="legend-badge legend-badge--payment" aria-hidden="true">💰</span>支付类</legend>
      <div class="button-group">
        <button :disabled="loading" @click="fetchQrcode"><span class="btn-icon" aria-hidden="true">💳</span>交款码</button>
        <button :disabled="loading" @click="refetchQrcode"><span class="btn-icon" aria-hidden="true">🔄</span>刷新</button>
        <button :disabled="loading" @click="fetchyimatongQrcode"><span class="btn-icon" aria-hidden="true">🔗</span>一码通</button>
        <button :disabled="loading" @click="fetchNoweizhangData"><span class="btn-icon" aria-hidden="true">🎁</span>查询奖励</button>
      </div>
    </fieldset>


    <fieldset class="action-group action-group--service">
      <legend><span class="legend-badge legend-badge--service" aria-hidden="true">💬</span>客户服务类</legend>
      <div class="button-group">
        <button :disabled="loading" @click="fetchKeqiAIData"><span class="btn-icon" aria-hidden="true">🤖</span>AI话术</button>
        <button :disabled="loading" @click="createGroupChat"><span class="btn-icon" aria-hidden="true">👥</span>建退车群</button>
      </div>
    </fieldset>

    <!-- 奖励记录区：整组可折叠 + 内部展开更多（>3 条时仅展示前 3 条） -->
    <div v-if="hasQueriedReward" class="collapsible-section record-section">
      <div class="section-header" @click="recordSectionCollapsed = !recordSectionCollapsed" role="button"
        :aria-expanded="!recordSectionCollapsed" tabindex="0"
        @keydown.enter.prevent="recordSectionCollapsed = !recordSectionCollapsed"
        @keydown.space.prevent="recordSectionCollapsed = !recordSectionCollapsed">
        <span>奖励记录（{{ recordsList.length }}）</span>
        <span class="toggle-icon">{{ recordSectionCollapsed ? '▶' : '▼' }}</span>
      </div>
      <div v-show="!recordSectionCollapsed">
        <div v-if="recordsList.length === 0" class="record-empty">
          暂无奖励信息，请联系财务核对。
        </div>
        <div v-for="record in displayedRecords" :key="record.id" class="record-item">
          <p>
            {{ record.billName }} - {{ record.status }} - {{ record.operatorStatus }}<br />
            {{ record.billStart }}~{{ record.billEnd }}：{{ record.value }}
          </p>
          <span v-if="record.remark">备注：{{ record.remark }}</span>
          <button @click="openDialog(record.id, record.remark || '')" :disabled="updating">
            编辑备注
          </button>
          <hr />
        </div>
        <div v-if="hasMoreRecords" class="record-actions">
          <button class="btn-link" @click="recordExpanded = !recordExpanded">
            {{ recordExpanded ? '收起' : `展开剩余 ${recordsList.length - 3} 条` }}
          </button>
        </div>
      </div>
    </div>

    <!-- 对话框（简易版，可用 Element Plus / Naive UI 等替换） -->
    <div v-if="dialogVisible" class="dialog-overlay">
      <div class="dialog">
        <h3>填写备注</h3>
        <input ref="remarkInputRef" v-model="remarkInput" type="text" placeholder="请输入备注"
          style="width: 100%; padding: 8px; margin: 10px 0;" />
        <div>
          <button @click="confirmUpdate" :disabled="updating">确定</button>
          <button @click="dialogVisible = false" :disabled="updating">取消</button>
        </div>
      </div>
    </div>

  </div>

</template>

<script setup>
import { onMounted, ref, computed, nextTick, watch } from 'vue';
import * as ww from '@wecom/jssdk'
import { xzsApi, lifeApi } from './api';

// 工具函数：延迟
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// ========== 请求日志结构 ==========
// 原 button1data 是字符串累加拼接，不方便单独展示“最新一条”，也不利于后续扩展。
// 改为数组后：logText（全部）+ latestLogText（最新一条）可分别由 computed 提供。
const logEntries = ref([]);

// 工具函数：向日志追加一条响应
const appendLog = (data) => {
  logEntries.value.push({
    ts: Date.now(),
    text: String(data ?? '')
  });
};

// 全部日志文本（用原 --- 风格分隔，保留原视觉）
const logText = computed(() =>
  logEntries.value.map(e => e.text).join('\n-----------------\n')
);
// 仅最新一条响应文本（日志折叠状态下的预览内容）
const latestLogText = computed(() => {
  if (logEntries.value.length === 0) return '';
  return logEntries.value[logEntries.value.length - 1].text;
});
// 是否有任何日志（控制整个区块是否可见）
const hasLogs = computed(() => logEntries.value.length > 0);

// ========== 签名缓存（sessionStorage） ==========
// 企业微信 JSAPI 签名有效期为 2 小时，这里用 30 分钟 TTL 保守取值。
// 缓存后即使页面刷新、HMR、或其他原因再次进入 initializeWW()，也不会重复请求 /signnew/。
const SIGN_CACHE_KEY = 'wecom_sign_cache_v1';
const SIGN_CACHE_TTL_SEC = 30 * 60; // 30 分钟

const getCachedSign = () => {
  try {
    const raw = sessionStorage.getItem(SIGN_CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const signTs = parseInt(parsed?.data?.timestamp, 10);
    if (!signTs || !parsed.data) return null;
    const ageSec = Math.floor(Date.now() / 1000) - signTs;
    if (ageSec >= SIGN_CACHE_TTL_SEC) {
      sessionStorage.removeItem(SIGN_CACHE_KEY);
      return null;
    }
    return parsed.data;
  } catch {
    return null;
  }
};

const setCachedSign = (data) => {
  try {
    sessionStorage.setItem(
      SIGN_CACHE_KEY,
      JSON.stringify({ data, cachedAt: Math.floor(Date.now() / 1000) })
    );
  } catch {
    // sessionStorage 不可用时静默忽略
  }
};

// ========== 状态变量 ==========
const remark = ref('')
const orderid = ref('')
const carNo = ref('')
const singdata = ref('')
const userid = ref('')
const loading = ref(true);
const error = ref(null);
const toastMsg = ref('');
let toastTimer = null;
// 请求日志已重构为 logEntries 数组 + computed（见上方 appendLog 区域）
const QrodeUrl = ref('');
const QrodeUrllink = ref('');
const chezhengUrl = ref('');
const jiaoqiangUrl = ref('');
const shangyeUrl = ref('');
const comUsername = ref('')
const hasQueriedReward = ref(false);
// 记录上一次查询保单的车牌，用于避免重复请求 /pdfToImage
const warrantyCarNo = ref('');

let isInitialized = false;
let initializationPromise = null;
let signRequestPromise = null;

const recordsList = ref([]);
const dialogVisible = ref(false);
const currentRecordId = ref(null);
const remarkInput = ref('');
const updating = ref(false);

// ========== 折叠状态 ==========
// 图片区折叠头（默认展开）。仅切换内部 v-show，不影响 URL 本身，
// @error 清空后外层 v-if 会隐藏整个区域
const imageSectionCollapsed = ref(false);
// 奖励记录列表整组折叠头（默认展开）
const recordSectionCollapsed = ref(false);
// 记录列表内部展开：>3 条时仅展示前 3 条 + 「展开剩余 N 条」按钮
const recordExpanded = ref(false);
// 客户备注折叠头（默认展开，备注是核心信息）
const remarkSectionCollapsed = ref(false);
// 请求日志折叠头（默认折叠，避免日志堆积占屏；折叠态下仅预览最新一条）
const logSectionCollapsed = ref(true);

// 始终显示前 3 条；展开后展示全部
const displayedRecords = computed(() => {
  if (recordExpanded.value || recordsList.value.length <= 3) {
    return recordsList.value;
  }
  return recordsList.value.slice(0, 3);
});
const hasMoreRecords = computed(() => recordsList.value.length > 3);

// ========== 轻提示 toast ==========
const showToast = (msg) => {
  toastMsg.value = msg;
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => { toastMsg.value = ''; }, 2500);
};

// ========== 对话框相关 ==========
const remarkInputRef = ref(null);
const openDialog = (id, remarkText) => {
  currentRecordId.value = id;
  remarkInput.value = remarkText;
  dialogVisible.value = true;
  // 打开后自动聚焦输入框，省去手动点击
  nextTick(() => remarkInputRef.value?.focus());
};

const confirmUpdate = async () => {
  if (updating.value) return;

  updating.value = true;
  try {
    const payload = {
      id: currentRecordId.value,
      remark: remarkInput.value.trim(),
      operator: comUsername.value,
    };

    await lifeApi.put('/api/reduction', payload, {
      headers: { 'Content-Type': 'application/json' }
    });

    const index = recordsList.value.findIndex(r => r.id === currentRecordId.value);
    if (index !== -1) {
      recordsList.value[index].remark = remarkInput.value.trim();
    }

    dialogVisible.value = false;
    showToast('备注更新成功！');
  } catch (err) {
    showToast('更新失败: ' + (err.response?.data?.message || err.message));
  } finally {
    updating.value = false;
  }
};

// ========== 通用请求函数 ==========
// 防重复提交统一由 loading（模板 :disabled）保证；
// 失败时只展示错误信息，不再 rethrow，避免点击处理器产生未捕获的 Promise 拒绝
const request = async ({ api, url, params = {}, append = true, onSuccess = null, onError = null }) => {
  loading.value = true;
  error.value = null;
  const instance = api === 'life' ? lifeApi : xzsApi;

  try {
    const response = await instance.get(url, { params });
    if (onSuccess) {
      onSuccess(response.data);
    } else if (append) {
      appendLog(response.data);
    }
    return response.data;
  } catch (err) {
    error.value = `请求失败: ${err.message}`;
    if (onError) {
      onError(err);
    }
    return null;
  } finally {
    loading.value = false;
  }
};

// ========== 业务函数 ==========
const fetchData = () => request({ url: `/122/${carNo.value}`, params: { comUsername: comUsername.value } });
const fetchHTData = () => request({ url: `/sohetong/${carNo.value}`, params: { comUsername: comUsername.value } });
const fetchDWData = () => request({ url: `/carapilocation/${carNo.value}`, params: { comUsername: comUsername.value } });
const fetchKeqiAIData = () => request({ url: `/ai/${carNo.value}`, params: { comUsername: comUsername.value } });
const fetchMileData = () => request({ url: `/carapimile/${carNo.value}`, params: { comUsername: comUsername.value } });
const fetchCZGPSData = () => request({ url: `/carczgps/${carNo.value}`, params: { comUsername: comUsername.value } });
const fetchZDData = () => request({
  url: `/carapizhangdan/${carNo.value}`,
  params: { comUsername: comUsername.value, orderid: orderid.value }
});

const fetchQrcode = () => request({
  url: `/qrcode/${orderid.value}`,
  params: { comUsername: comUsername.value },
  append: false,
  onSuccess: (data) => { QrodeUrl.value = data; }
});

const fetchyimatongQrcode = () => request({
  api: 'life',
  url: `/api/order/generate2`,
  params: { orderId: orderid.value },
  append: false,
  onSuccess: (data) => {
    QrodeUrl.value = data?.data?.QrcodeUrl;
    QrodeUrllink.value = data?.data?.url;
  }
});

const refetchQrcode = () => request({
  url: `/reqrcode/${carNo.value}`,
  params: { comUsername: comUsername.value },
  append: false,
  onSuccess: (data) => { QrodeUrl.value = data; }
});

// 复用通用 request，保持与其他按钮一致的错误/加载处理
const fetchNoweizhangData = () => request({
  api: 'life',
  url: '/api/reduction',
  params: { page: 1, size: 100, orderId: orderid.value },
  append: false,
  onSuccess: (data) => {
    recordsList.value = data?.data?.records || [];
    hasQueriedReward.value = true;
  },
  onError: () => {
    recordsList.value = [];
  }
});

// ========== 企业微信 SDK ==========
const getConfigSignature = async () => {
  if (!singdata.value) return null;
  return {
    timestamp: singdata.value['timestamp'],
    nonceStr: singdata.value['nonceStr'],
    signature: singdata.value['signatureCom'],
  }
}

const getAgentConfigSignature = async () => {
  if (!singdata.value) return null;
  return {
    timestamp: singdata.value['timestamp'],
    nonceStr: singdata.value['nonceStr'],
    signature: singdata.value['signatureAG'],
  }
}

const registerWW = () => {
  ww.register({
    corpId: process.env.VUE_APP_WECOM_CORP_ID || 'ww2fcd8b58ddfada9e',
    agentId: process.env.VUE_APP_WECOM_AGENT_ID || '1000032',
    jsApiList: ['getCurExternalContact', 'openEnterpriseChat', 'sendChatMessage'],
    getConfigSignature,
    getAgentConfigSignature,
    // 仅开发环境开启调试，避免生产环境泄露内部信息
    debug: process.env.NODE_ENV !== 'production'
  });
};

const initializeWW = async () => {
  // 1. 内存中已有签名，直接跳过（包括已注册过 ww.register 的情况）
  if (singdata.value) {
    console.log('已有签名数据，跳过初始化');
    return;
  }

  // 2. sessionStorage 缓存中仍有有效签名，直接复用，不发请求
  const cached = getCachedSign();
  if (cached) {
    console.log('使用 sessionStorage 中缓存的签名数据（30 分钟内有效）');
    singdata.value = cached;
    registerWW();
    return;
  }

  // 3. 已有进行中的请求，复用其 Promise，避免并发
  if (signRequestPromise) {
    console.log('签名请求正在进行中，等待完成...');
    return signRequestPromise;
  }

  // 4. 真正发起请求
  signRequestPromise = (async () => {
    try {
      console.log('开始初始化企业微信SDK...');

      const response = await xzsApi.get('/signnew/');
      singdata.value = response.data;
      // 写入缓存，下次进入（包括页面刷新）可直接复用
      setCachedSign(response.data);

      registerWW();
      console.log('企业微信SDK注册完成');
    } catch (err) {
      console.error('初始化失败:', err);
      error.value = '初始化企业微信SDK失败: ' + err.message;
      throw err;
    } finally {
      signRequestPromise = null;
    }
  })();

  return signRequestPromise;
}

// ========== 创建退车群 ==========
const createGroupChat = async () => {
  loading.value = true;
  error.value = null;
  try {
    console.log('创建退车群...');
    const currentDate = new Date();
    const year = String(currentDate.getFullYear()).slice(-2);
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const result = "-" + year + "-" + month + '退车群';
    ww.openEnterpriseChat({
      groupName: carNo.value + result,
      userIds: [
        comUsername.value,
        process.env.VUE_APP_GROUP_COLLEAGUE || 'liujian2'
      ],
      externalUserIds: [
        userid.value
      ]
    })
    console.log('创建退车群完成');
  } catch (err) {
    console.error('创建退车群失败:', err);
    error.value = '创建退车群失败: ' + err.message;
  } finally {
    loading.value = false;
  }
};

// ========== 获取外部用户ID ==========
const getUserId = async () => {
  try {
    return new Promise((resolve, reject) => {
      ww.getCurExternalContact({
        success(result) {
          console.log('成功获取外部用户ID:', result['userId']);
          resolve(result['userId']);
        },
        fail(result) {
          console.error('获取用户ID失败:', result);
          reject(new Error('获取用户ID失败'));
        }
      });
    });
  } catch (err) {
    console.error('获取用户ID失败:', err);
    error.value = '获取用户ID失败: ' + err.message;
  }
}

// ========== 获取用户备注信息 ==========
const fetchUser = async () => {
  if (!userid.value) {
    console.log('未获取到用户ID，跳过获取备注信息');
    return;
  }
  loading.value = true;
  error.value = null;
  try {
    const url = `/userremark2/${userid.value}?comuserid=${encodeURIComponent(localStorage.getItem('comUsername'))}`;
    const response = await xzsApi.get(url);
    const res = response.data;

    remark.value = res['msg'];
    orderid.value = res['orderid'];
    carNo.value = res['carno'];
    console.log('成功获取用户备注信息:', response.data);
  } catch (err) {
    console.error('获取用户备注信息失败:', err);
    error.value = '获取用户备注信息失败: ' + err.message;
  } finally {
    loading.value = false;
  }
}

// ========== 应用初始化 ==========
async function initApp() {
  if (isInitialized) {
    console.log('应用已初始化，跳过重复执行');
    return Promise.resolve();
  }

  if (initializationPromise) {
    console.log('初始化已在进行中，等待完成...');
    return initializationPromise;
  }

  console.log('开始初始化应用...');

  initializationPromise = (async () => {
    try {
      await initializeWW();

      let retryCount = 0;
      const maxRetries = 3;
      let userId = null;

      while (retryCount < maxRetries && !userId) {
        try {
          userId = await getUserId();
          console.log(`第 ${retryCount + 1} 次尝试获取用户ID成功:`, userId);
        } catch (err) {
          console.log(`第 ${retryCount + 1} 次获取用户ID失败:`, err.message);
          retryCount++;
          if (retryCount < maxRetries) {
            console.log('等待1秒后重试...');
            await delay(1000);
          }
        }
      }

      if (userId) {
        userid.value = userId;
        await fetchUser();
        // 保存原始用户名，编码统一交给 axios params / 拼 URL 处处理，避免双重编码
        comUsername.value = localStorage.getItem('comUsername') || ''
        isInitialized = true;
        console.log('初始化成功完成');
      } else {
        userid.value = '初始化-没有获取用户ID';
        console.log('达到最大重试次数仍未获取到用户ID');
        throw new Error('无法获取用户ID');
      }
    } catch (err) {
      console.error('初始化流程失败:', err);
      error.value = '初始化流程失败: ' + (typeof err === 'string' ? err : err.message);
      isInitialized = false;
      initializationPromise = null;
    } finally {
      loading.value = false;
    }
  })();

  return initializationPromise;
}

// ========== 生命周期 ==========
onMounted(async () => {
  const authCode = localStorage.getItem('oauth_code')
  console.log('authcode:', authCode)
  if (authCode) {
    await initApp()
  } else {
    // 无授权 code 的干净页面：结束 loading，避免页面永久卡在“获取数据中”且按钮全部禁用
    console.log('干净页面，未携带授权 code')
    loading.value = false
    error.value = '请在企业微信客户会话中打开本页面'
  }
});

// ========== 保单车证相关 ==========
// 后端 /pdfToImage 接口已支持 user 参数（async def pdf_to_image(carNo, type, user='')）
// 该参数会告诉后端是谁在查询保单，便于审计/统计
// 图片加载失败时通过模板中的 @error 直接清空对应 URL，避免显示 404 图标
const fetchWarrantyStatus = () => {
  const carno = carNo.value;
  if (!carno) {
    error.value = '车牌号为空';
    return;
  }

  // 同一车牌且图片仍在展示时，不重复请求后端 /pdfToImage；
  // 图片加载失败被 @error 清空后，再次点击可正常重试
  if (warrantyCarNo.value === carno && (jiaoqiangUrl.value || shangyeUrl.value)) {
    console.log('该车牌保单图片已加载，跳过重复请求');
    return;
  }

  loading.value = true;
  try {
    const encodedCarNo = encodeURIComponent(carno);
    // 优先使用 comUsername（登录用户名），否则用 userid（外部用户ID）
    const currentUser = comUsername.value || userid.value || '';
    const encodedUser = encodeURIComponent(currentUser);

    // 车证图片（直接走 COS，不经过后端）
    chezhengUrl.value = `https://life-1328614890.cos.ap-chengdu.myqcloud.com/车证/${encodedCarNo}.jpg`

    // 交强险/商业险走后端 /pdfToImage 接口（baseURL 从 api 实例取，随环境变量切换）
    // URL 中带 user 参数让后端知道是谁在查询（后端可记录访问日志）
    jiaoqiangUrl.value = `${xzsApi.defaults.baseURL}/pdfToImage?carNo=${encodedCarNo}&type=jiaoqiang&user=${encodedUser}`
    shangyeUrl.value = `${xzsApi.defaults.baseURL}/pdfToImage?carNo=${encodedCarNo}&type=shangye&user=${encodedUser}`

    warrantyCarNo.value = carno;
  } catch (err) {
    error.value = '获取车证信息失败: ' + err.message;
  } finally {
    loading.value = false;
  }
};

// ========== 联系人备注解析 ==========
// 一行格式示例：
//   26-04-08 12:41:30：祝苗=>陈程
//   26-05-17 14:09:39：胡林森13397626994=>陈程
// 兼容：
//   · 年份 2 位或 4 位（26 或 2026）
//   · 日期分隔符 - 或 /
//   · 时间分隔符 ：（中文）或 :（半角）
//   · 操作人含手机号、目标人含车牌号
const CONTACT_LOG_REGEX = /^(\d{2,4}[-/]\d{1,2}[-/]\d{1,2}\s+\d{1,2}:\d{1,2}:\d{1,2})[：:](.+?)=>(.+?)\s*$/;

// 联系人备注部分（与高亮分高亮逻辑独立处理）
const parsedContactLogs = computed(() => {
  if (!remark.value) return [];
  return remark.value
    .split(/\r?\n/)
    .map(line => {
      const m = line.match(CONTACT_LOG_REGEX);
      if (!m) return null;
      return {
        date: m[1],
        operator: m[2].trim(),
        target: m[3].trim(),
      };
    })
    .filter(Boolean);
});

// 排除联系人行与「各联系人备注：」原标题行后的剩余内容
// （折叠头取代原文字，避免重复展示）
const remarkWithoutContacts = computed(() => {
  if (!remark.value) return '';
  return remark.value
    .split(/\r?\n/)
    .filter(line => {
      if (CONTACT_LOG_REGEX.test(line)) return false;
      if (/^\s*各联系人备注\s*[：:]?\s*$/.test(line)) return false;
      return true;
    })
    .join('\n');
});

// “各联系人备注” 组级折叠头（默认折叠，避免页面一打开就被联系人列表占据）
const contactLogsCollapsed = ref(true);

// 备注重新加载时，折叠状态重置为全折叠
watch(parsedContactLogs, () => {
  contactLogsCollapsed.value = true;
});

// ========== 高亮到期日期 ==========
const DATE_REGEX = /(到期[：:]\s*(\d{4})-(\d{1,2})-(\d{1,2})(?:\s+\d{1,2}:\d{1,2}:\d{1,2})?|车辆年审[：:]\s*(\d{4})-(\d{1,2})-(\d{1,2})|车证年检到期[：:]\s*(\d{4})(\d{1,2})(\d{1,2}))/g;

// HTML 转义，防止备注内容携带的 HTML/脚本通过 v-html 注入（XSS）
const escapeHtml = (str) => String(str)
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#39;');

const highlightedB = computed(() => {
  if (!remarkWithoutContacts.value) return remarkWithoutContacts.value;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const oneMonthLater = new Date(today);
  oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);

  // 先转义再做日期高亮，高亮 span 是白名单内的安全内容
  return escapeHtml(remarkWithoutContacts.value).replace(DATE_REGEX, (match, ...args) => {
    let y, m, d;
    if (args[1]) {
      y = +args[1]; m = +args[2]; d = +args[3];
    } else if (args[4]) {
      y = +args[4]; m = +args[5]; d = +args[6];
    } else if (args[7]) {
      y = +args[7]; m = +args[8]; d = +args[9];
    } else {
      return match;
    }

    const target = new Date(y, m - 1, d);
    if (target < today) {
      return `<span class="highlight highlight-expired">${match}</span>`;
    } else if (target <= oneMonthLater) {
      return `<span class="highlight">${match}</span>`;
    }
    return match;
  });
});
</script>

<style scoped>
/* 容器样式 */
.remark-container {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  max-width: 600px;
  margin: 20px auto;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  white-space: pre-wrap;
  font-size: 16px;
}

/* v-html 注入的内容需要 :deep 才能命中 scoped 样式 */
:deep(.highlight) {
  color: red;
}

:deep(.highlight-expired) {
  color: red;
  font-weight: bold;
}

/* 错误文本样式（合并后统一显示） */
.error-text {
  color: red;
  background-color: #fff5f5;
  border: 1px solid #ffccc7;
  border-radius: 4px;
  padding: 8px 12px;
  margin: 8px 0;
}

/* 标题样式 */
.remark-header {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}

.no-wrap {
  white-space: nowrap;
}

/* ========== 折叠卡片统一外观 ==========
   核心思路：外层 .collapsible-section 作为唯一的「卡片」轮廓（边框/圆角/阴影），
   折叠头 .section-header 与内容区都不再各自画边框，连为同一张卡片。
   折叠头与内容之间仅用一条 1px 分隔线衔接，消除「两层皮」的割裂感。 */

/* 折叠卡片：统一的外轮廓 */
.collapsible-section {
  margin: 10px 0;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background-color: #fff;
  transition: box-shadow 0.15s ease;
}

/* 整张卡片 hover 轻微浮起，强化“整体感” */
.collapsible-section:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* 折叠头：不带独立边框/圆角，由外层卡片接管 */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  background-color: #f5f5f5;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
  color: #333;
  font-weight: 500;
  transition: background-color 0.15s ease;
}

/* 展开态：头部底部加 1px 细分隔线，与下方内容自然衔接 */
.section-header[aria-expanded="true"] {
  border-bottom: 1px solid #ebebeb;
}

.section-header:hover {
  background-color: #eaeaea;
}

.section-header:focus-visible {
  outline: 2px solid #1890ff;
  outline-offset: -2px;
}

.toggle-icon {
  font-size: 12px;
  color: #666;
  transition: transform 0.2s ease;
}

/* ========== 「各联系人备注」内部组级折叠 ==========
   位于 .remark-container 内部，是客户信息卡的次级折叠。 */
.contact-logs {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px dashed #e0e0e0;
}

.contact-log-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  background-color: #f9f9f9;
  border: 1px solid #eee;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
  font-size: 13px;
  color: #555;
  transition: background-color 0.15s ease;
}

.contact-log-header:hover {
  background-color: #efefef;
}

.contact-log-header:focus-visible {
  outline: 2px solid #1890ff;
  outline-offset: 1px;
}

/* 展开态：折叠头底部变平，与下方列表无缝拼接 */
.contact-log-header[aria-expanded="true"] {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-color: transparent;
  margin-bottom: -1px;
}

.contact-log-list {
  list-style: none;
  margin: 0;
  padding: 6px 12px;
  border: 1px solid #eee;
  border-top: none;
  border-radius: 0 0 4px 4px;
  background-color: #fff;
  font-size: 13px;
  color: #444;
  max-height: 200px;
  overflow: auto;
}

.contact-log-item {
  padding: 4px 0;
  line-height: 1.5;
  font-variant-numeric: tabular-nums;
}

.contact-log-item + .contact-log-item {
  border-top: 1px dashed #f5f5f5;
}

/* ========== 折叠区内子元素重置 ==========
   脱掉原 remark-container/image-wrapper/record-empty/record-actions
   独立的边框/圆角/阴影/外边距，让它们与折叠头连为一张卡片。 */
.collapsible-section > .remark-container,
.collapsible-section > .image-wrapper,
.collapsible-section > .record-empty,
.collapsible-section > .record-actions,
.collapsible-section > .log-latest,
.collapsible-section > .log-all {
  border: none;
  border-radius: 0;
  box-shadow: none;
  margin: 0;
  max-width: none;
  padding: 14px;
}

/* 日志预览模式：保留“预览”标识（左侧色条 + 浅蓝背景） */
.collapsible-section > .log-latest {
  border-left: 3px solid #1890ff;
  background-color: #f0f7ff;
}

/* 日志全部模式：与卡片同色，不抢眼 */
.collapsible-section > .log-all {
  background-color: #fafafa;
}

/* 记录项：脱掉独立边框，用 border-top 分隔连续记录 */
.collapsible-section .record-item {
  border: none;
  border-radius: 0;
  margin: 0;
  padding: 10px 14px;
}

.collapsible-section .record-item + .record-item {
  border-top: 1px solid #f0f0f0;
}

/* 折叠区内的 <hr/> 不再需要（改用 border-top） */
.collapsible-section .record-item hr {
  display: none;
}

/* 记录列表空状态 */
.record-empty {
  padding: 14px;
  color: #999;
  text-align: center;
  background-color: #fafafa;
  border: 1px dashed #e0e0e0;
  border-radius: 4px;
  margin: 10px 0;
  font-size: 14px;
}

/* 「展开剩余 N 条」按钮容器 */
.record-actions {
  text-align: center;
  margin: 10px 0;
}

/* 折叠态：仅显示最新一条响应。
   左侧加一个细竖条 + 背景轻色，提示这是「预览」而非「全部」。
   不限高度，内容按自然尺寸完整展开。 */
.log-latest {
  position: relative;
  border-left: 3px solid #1890ff;
  background-color: #f0f7ff;
}

/* 展开态：展示全部日志。
   不限高度，按原始响应体积完全展开（沿用 --- 分隔可视化）。 */
.log-all {
  /* 完全展开 */
}

/* 链接样式按钮（覆盖默认 button 蓝色背景） */
.btn-link {
  background-color: #fff;
  color: #1890ff;
  border: 1px solid #1890ff;
  height: auto;
  padding: 6px 16px;
  font-size: 13px;
}

.btn-link:hover:not(:disabled) {
  background-color: #e6f7ff;
  color: #096dd9;
  border-color: #096dd9;
}

.btn-link:disabled {
  background-color: #f5f5f5;
  color: #ccc;
  border-color: #ccc;
}

.image-wrapper {
  width: 100%;
  padding: 20px 0;
  text-align: center;
}

.auto-fit-image {
  width: 70%;
  height: auto;
  max-width: 100%;
  display: inline-block;
  border-radius: 8px;
}

/* ========== 按钮分组（语义化分组） ==========
   用 fieldset + legend 实现语义化分组，
   .button-group 复用为各分组内的 flex 容器（自动换行）。 */
.action-group {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin: 12px 0;
  padding: 12px 14px 14px;
  background-color: #fff;
}

.action-group legend {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
  font-size: 13px;
  font-weight: 500;
  color: #666;
  /* 抹除 legend 默认边框，让标题与卡片融为一体 */
  border: 0;
  background-color: #fff;
}

/* legend 内的品牌色图标徽章（圆形背景 + 白底图标） */
.legend-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  font-size: 13px;
  line-height: 1;
  color: #fff;
  margin-right: 2px;
  flex-shrink: 0;
  /* 兼容彩色 emoji 字体，避免某些系统上默认 emoji 为黑白色 */
  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji',
    'Microsoft YaHei', sans-serif;
}

.legend-badge--vehicle {
  background-color: #1890ff; /* 蓝 · 车辆数据 */
}

.legend-badge--service {
  background-color: #52c41a; /* 绿 · 客户服务 */
}

.legend-badge--payment {
  background-color: #fa8c16; /* 橙 · 支付 */
}

/* 三个分组采用不同色系区分语义 */
.action-group--vehicle legend {
  color: #1890ff; /* 蓝 · 车辆数据 */
}

.action-group--service legend {
  color: #52c41a; /* 绿 · 客户服务 */
}

.action-group--payment legend {
  color: #fa8c16; /* 橙 · 支付 */
}

/* 按分组为按钮调色（Ant Design 浅色填充风格）
   浅色背景 + 深色文字 + 同色系边框，区分度高且不刺眼 */

/* 车辆数据类 · 蓝 */
.action-group--vehicle .button-group button {
  background-color: #e6f7ff;
  color: #1890ff;
  border: 1px solid #91d5ff;
}
.action-group--vehicle .button-group button:hover:not(:disabled) {
  background-color: #bae0ff;
  border-color: #69c0ff;
}

/* 客户服务类 · 绿 */
.action-group--service .button-group button {
  background-color: #f6ffed;
  color: #52c41a;
  border: 1px solid #b7eb8f;
}
.action-group--service .button-group button:hover:not(:disabled) {
  background-color: #d9f7be;
  border-color: #95de64;
}

/* 支付类 · 橙 */
.action-group--payment .button-group button {
  background-color: #fff7e6;
  color: #fa8c16;
  border: 1px solid #ffd591;
}
.action-group--payment .button-group button:hover:not(:disabled) {
  background-color: #ffe7ba;
  border-color: #ffc069;
}

/* 三组 disabled 状态：统一谈化为灰色 */
.action-group .button-group button:disabled {
  background-color: #f5f5f5;
  color: #bfbfbf;
  border-color: #e8e8e8;
}

/* 按钮组样式 */
.button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin: 4px 0 0;
}

/* 按钮全局基础样式（颜色与边框由所在分组覆盖，
   对话框里的 button 等不加分组的按钮默认走这条主色） */
button {
  cursor: pointer;
  background-color: #f5f5f5;
  color: #333;
  border: 1px solid #d9d9d9;
  padding: 6px 12px;
  font-size: 14px;
  height: 28px;
  min-width: 50px;
  border-radius: 4px;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease;
}

/* 按钮内的细分组图标（与文字同行） */
.btn-icon {
  display: inline-block;
  margin-right: 4px;
  font-size: 13px;
  line-height: 1;
  /* 兼容彩色 emoji，避免某些系统中变成黑白 */
  font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji',
    'Microsoft YaHei', sans-serif;
}

/* 无分组的默认按钮 hover/disabled（分组按钮已被更具体规则覆盖） */
button:hover:not(:disabled) {
  background-color: #e8e8e8;
  border-color: #bfbfbf;
}

button:disabled {
  background-color: #f5f5f5;
  color: #bfbfbf;
  border-color: #e8e8e8;
  cursor: not-allowed;
}

.record-item {
  margin: 10px 0;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 4px;
}

.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.dialog {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 300px;
}

/* 轻提示 toast */
.toast {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  z-index: 10000;
}
</style>